/**
 * Header Scroll Behavior
 * Show header on scroll up, hide on scroll down
 */

(function() {
  const header = document.querySelector('.header');
  if (!header) return;

  let lastScroll = 0;
  const scrollThreshold = 100;

  window.addEventListener('scroll', function() {
    const currentScroll = window.pageYOffset;

    // Don't hide header at the very top
    if (currentScroll <= scrollThreshold) {
      header.classList.remove('header--hidden');
      lastScroll = currentScroll;
      return;
    }

    // Scrolling down - hide header
    if (currentScroll > lastScroll && currentScroll > scrollThreshold) {
      header.classList.add('header--hidden');
    } 
    // Scrolling up - show header
    else if (currentScroll < lastScroll) {
      header.classList.remove('header--hidden');
    }

    lastScroll = currentScroll;
  });
})();
